import { DataTypeSearchCombo, SearchQuery } from '../Query';
import { isDataTypeSearchComboArray } from './isDataTypeSearchComboArray';

export const ensureDataTypeSearchComboArray = (
  arr: DataTypeSearchCombo[] | SearchQuery[],
): DataTypeSearchCombo[] => (isDataTypeSearchComboArray(arr) ? arr : []);
